module.exports = __webpack_public_path__ + "img/game--sims-4.cd78a23c.png";